/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createViewerRelationshipHook } from '../../core/factories/createViewerRelationshipHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetWatchlistRow } from '../openapi-types.gen.js';
import { type useGetWatchlistArgs, useGetWatchlistSpec } from '../specs/watchlist.spec.gen.js';

export type { GetWatchlistRow } from '../openapi-types.gen.js';
export type { useGetWatchlistArgs } from '../specs/watchlist.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): kind.
 */
export const useGetWatchlist = createViewerRelationshipHook(useGetWatchlistSpec);


/**
 * Hover/intent prefetch companion for `useGetWatchlist`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetWatchlist();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetWatchlist = createPrefetchHook(useGetWatchlistSpec);
